// extracted by mini-css-extract-plugin
export default {"blockMarkdown":"_8d1b0280b48762bb52535412c653d763-scss"};